import { Injectable } from '@angular/core';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { NarudzbeService } from '../pages/narudzbe/narudzbe.service';
import { AuthService } from '../shared/services';
import { PageOrientation } from 'pdfmake/interfaces';
import { TableLayout } from 'pdfmake/interfaces';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaNarudzbeService {

  deklaracije: any = [];

  groupedData: any;

  constructor(private service: NarudzbeService, private authService: AuthService) {}

  pdfNarudzba(data) {
    console.log('data: ', data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service.dokumentstavkePopis({ idkorisnik: localStorage.getItem('idsecuser'), idfirma: localStorage.getItem('firma'), iddokument: data.data.do_id }).subscribe((res) => {
      console.log(res);
      if (res.success === true) {

        this.deklaracije = res.deklaracije;

        let ct = [];
        
        ct.push({
          text: 'PEKAR d.o.o.',
          style: 'title',
        });

        ct.push({
          text: 'Obrtnička ulica 5 \n 32100 Vinkovci',
          style: 'subtitle',
          margin: [0, 0, 0, 15],
        });

        ct.push({
          columns: [
            {
              table: {
                widths: [200],
                body: [
                  [
                    {
                      table: {
                        body: [
                          [
                            {
                              text: 'Datum narudžbe: ' + moment(data.data.datum_narudzbe).format('DD.MM.YYYY') + '.',
                              style: 'details',
                            },
                          ],
                          [
                            {
                              text: 'Partner:',
                              style: 'details',
                            },
                          ],
                          [
                            {
                              text:
                                data.data.pa_naziv +
                                ' \n ' +
                                data.data.pp_naziv +
                                ' \n\n',
                              style: 'tableTitle',
                            },
                          ],
                        ],
                      },
                      layout: 'noBorders'
                    },
                  ],
                ],
              },
            },

            {
              /*
                QR kod redom sadrzi: 
                  do_id (iddokument), 
                  pa_idTomo (pa_id Pekar TOMO), 
                  pa_sifra_Tomo (pa_sifra Pekar TOMO), 
                  poslovnicapartnera_pp_idTomo (idskladiste od Pekar TOMO), 
                  pp_sifra_Tomo (pp_sifra od Pekar TOMO), 
                  pa_id (idkupac), 
                  poslovnicapartnera_pp_id (idposlovnica_kupca) 
                - takav REDOSLIJED ce se koristiti u mobilnoj app 
              */
             
              qr:
                'N;' +
                data.data.do_id +
                ';' +
                data.data.pa_idTomo +
                ';' +
                data.data.pa_sifra_Tomo +
                ';' +
                data.data.poslovnicapartnera_pp_idTomo +
                ';' +
                data.data.pp_sifra_Tomo +
                ';' +
                data.data.pa_id +
                ';' +
                data.data.poslovnicapartnera_pp_id,
              fit: '100',
              alignment: 'center',
            }
          ],
        });

        ct.push({
          text: 'Narudžba: ' + data.data.do_id + '\n' + 'Narudžbenica kupca: ' + `${data.data.do_brojnarudzbe || ''}`,
          style: 'mainTitle',
          alignment: 'center',
          margin: [0, 30, 0, 30],
        });

        let brojac = 1;
        let arr = res.data;
        //console.log('arr: ', arr);
        let result = arr.reduce(function (r, a) {
          r[a.ar_sifra] = r[a.ar_sifra] || [];
          r[a.ar_sifra].push(a);
          return r;
        }, Object.create(null));
        //console.log('result: ', result);

        ct.push({
          table: {
            widths: [15, 40, '*', 55, 50],
            body: [
              [
                'RB',
                'Šifra',
                'Naziv artikla',
                'Količina',
                'Broj paleta'
              ],
            ],
          },
          layout: 'lightHorizontalLines' as TableLayout,
        });

        ct.push(hLine);
        for (let lot in result) {
          let stavkaSifra = '';
          let stavkaNaziv = '';
          let stavkaKolicina = 0;
          let stavkaBrojPaleta = 0;
          for (let stavka of result[lot]) {
            stavkaSifra = stavka.ar_sifra;
            stavkaNaziv = stavka.ar_naziv;
            stavkaKolicina += stavka.ds_kolicina;
            stavkaBrojPaleta = stavka.broj_paleta;
          }

          ct.push({
            table: {
              widths: [15, 40, '*', 55, 50],
              body: [
                [
                  brojac++,
                  stavkaSifra,
                  stavkaNaziv,
                  { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right' },
                  { text: this.formatiraj(stavkaBrojPaleta, 2), alignment: 'right' }
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });
        }

  
        let signatureLine = {
          table: {
            widths: ['100%'],
            body: [[''], ['']],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
          },
        };

        ct.push({
          columns: [
            [
              {
                text: 'Potpis i pečat skladištara:',
                margin: [0, 60, 0, 30],
              },
              signatureLine,
            ],
            [],
            [],
            [
              {
                text: 'Potpis i pečat vozača:',
                alignment: 'right',
                margin: [0, 60, 0, 30],
              },
              signatureLine,
            ],
          ],
        });

        // Group data by ar_sifra
        const groupedObj = {};
        this.deklaracije.forEach(item => {
          if (!groupedObj[item.ar_sifra]) {
            groupedObj[item.ar_sifra] = {
              sifra: item.ar_sifra,
              naziv: item.ar_naziv,
              rows: []
            };
          }
          
          groupedObj[item.ar_sifra].rows.push({
            ds_id: item.ds_id,
            ar_id: item.ar_id,
            pd_sifra: item.pd_sifra,
            pdv_naziv: item.pdv_naziv,
            pdp_naziv_programa: item.pdp_naziv_programa,
            pdpi_naziv: item.pdpi_naziv,
            karton: item.karton,
            paleta: item.paleta
          });
        });

        
        const tableBody = [];
        tableBody.push([
          { text: 'Šifra', style: 'tableHeader' }, 
          { text: 'Artikl', style: 'tableHeader' }, 
          { text: 'Deklaracija', style: 'tableHeader' }, 
          { text: 'Vrsta', style: 'tableHeader' }, 
          { text: 'Program', style: 'tableHeader' },
          { text: 'Ispis print', style: 'tableHeader' },
          { text: 'Količina', style: 'tableHeader' },
        ]);

        if (res.deklaracije.length > 0) {
          ct.push(
            { text: 'Deklaracije', style: 'subtitle', margin: [0, 40, 0, 0] },
            {
              table: {
                headerRows: 1,
                widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
                body: tableBody
              },
              layout: {
                hLineWidth: function (i, node) {
                  // i === 1 → linija ispod headera
                  if (i === 1) return 0.5;

                  // linija ispod zadnje stavke svake grupe
                  return borderIndexes.includes(i) ? 0.5 : 0;
                },
                hLineColor: function (i, node) {
                  if (i === 1) return '#000000'; // crna za header
                  if (borderIndexes.includes(i)) return '#CCCCCC'; // siva za grupe
                  return '#FFFFFF'; // inače "nevidljiva"
                },
                vLineWidth: function () {
                  return 0;
                },
                paddingLeft: function () {
                  return 4;
                },
                paddingRight: function () {
                  return 4;
                },
                paddingTop: function () {
                  return 2;
                },
                paddingBottom: function () {
                  return 2;
                }
              }
            }
          );
      }

        const borderIndexes = [];
        let currentRowIndex = 1;
        this.groupedData = Object.values(groupedObj);
        console.log(this.groupedData);
        
        let kolicina = ''; 
        this.groupedData.forEach(group => {
          const rowCount = group.rows.length;
          
          group.rows.forEach((row, index) => {
            const tableRow = [];
            
            // Only add sifra and naziv for first row of each group
            if (index === 0) {
              tableRow.push({ text: group.sifra, rowSpan: rowCount });
              tableRow.push({ text: group.naziv, rowSpan: rowCount });
            } else {
              // For subsequent rows, add empty cells that will be part of the rowspan
              tableRow.push({});
              tableRow.push({});
            }
            
            // Add other cells
            tableRow.push({ text: row.pd_sifra });
            tableRow.push({ text: row.pdv_naziv });
            tableRow.push({ text: row.pdp_naziv_programa });
            tableRow.push({ text: row.pdpi_naziv });

            if (row.pdv_naziv === 'Kartonska') {
              kolicina = row.karton;
            }else if(row.pdv_naziv === 'Paletna'){
              kolicina = row.paleta;
            }

            tableRow.push({ text: kolicina, alignment: 'right' });
            
            tableBody.push(tableRow);
            currentRowIndex++;
          });
          borderIndexes.push(currentRowIndex);
        });
        

        var dd = {
          info: {
            title: 'Narudžba: ' + data.data.do_id,
          },
          content: ct,
          pageMargins: 20,
          defaultStyle: {
            fontSize: 9.5,
          },
          styles: {
            title: {
              fontSize: 15,
              bold: true,
            },
            subtitle: {
              fontSize: 12,
            },
            details: {
              fontSize: 11,
            },
            tableTitle: {
              fontSize: 13,
              bold: true,
            },
            mainTitle: {
              fontSize: 17,
              bold: true,
            },
            tableFooter: {
              bold: true,
            },
          },
        };

        pdfMake.createPdf(dd).open();
      }
    });
  }

  generirajPdfZaSveNarudzbe(narudzbeSaStavkama) {
    let pdfContent = [];
    console.log(narudzbeSaStavkama)
    pdfContent.push({
      text: 'PEKAR TOMO d.o.o. - Narudžbe sa razlikama',
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 20],
    });
  
    narudzbeSaStavkama.forEach(narudzba => {
      pdfContent.push({
        text: 'Datum narudžbe: ' + moment(narudzba.datum_narudzbe).format('DD.MM.YYYY') + '.',
        style: 'subTitle',
        margin: [0, 10, 0, 5],
      });
      
      pdfContent.push({
        text: `Narudžba: ${narudzba.do_brojnarudzbe || narudzba.do_id} - ${narudzba.pa_naziv} - ${narudzba.pp_naziv}`,
        style: 'subTitle',
        margin: [0, 10, 0, 5],
      });
  
      pdfContent.push({
        table: {
          widths: [15, 45, '*', 115, 115, 115],
          body: [
            ['RB', 'Šifra', 'Naziv artikla', 'Naručeno', 'Isporučeno', 'Razlika'],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0.5;
          },
          vLineWidth: function (i, node) {
            return 0.5;
          },
          hLineColor: function (i, node) {
            return '#000000';
          },
          vLineColor: function (i, node) {
            return '#000000';
          },
        },
      });
  
      narudzba.stavke.forEach((stavka, index) => {
        pdfContent.push({
          table: {
            widths: [15, 45, '*', 115, 115, 115],
            body: [
              [
                index + 1,
                stavka.ar_sifra ? stavka.ar_sifra : 'N/A',
                stavka.ar_naziv ? stavka.ar_naziv : 'N/A',
                { text: stavka.naruceno ? stavka.naruceno : 0, alignment: 'right' },
                { text: stavka.isporuceno ? stavka.isporuceno : 0, alignment: 'right' },
                { text: stavka.razlika ? stavka.razlika : 0, alignment: 'right' }
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.5;
            },
            vLineWidth: function (i, node) {
              return 0.5; 
            },
            hLineColor: function (i, node) {
              return '#000000'; 
            },
            vLineColor: function (i, node) {
              return '#000000'; 
            },
          },
        });
        console.log('index: ', index);
        console.log('narudzba.stavke.length: ', narudzba.stavke.length);
        if (index === (narudzba.stavke.length - 1)) {
          pdfContent.push({ text: '', pageBreak: 'after' });
        }
      });
    });
    
    let dd = {
      pageSize: {
        width: 595.28,
        height: 841.89   
      },
      pageOrientation: 'landscape' as PageOrientation,
      content: pdfContent,
      styles: {
        mainTitle: {
          fontSize: 15,
          bold: true,
        },
        subTitle: {
          fontSize: 12,
          bold: true,
        },
      },
    };
  
    pdfMake.createPdf(dd).open();
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }
}
